import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import useIsHovering from 'hooks/useIsHovering';

const WidgetStyle = styled.div`
  border-radius: 15px;
  background: white;
  cursor: pointer;
  padding: 30px 15px;
  margin: 20px;

  font-size: 18px;
  text-align: center;
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.27);
  opacity: 0.8;
  transition: all 0.2s;

  .icon {
    transition: font-size 0.2s;

    font-size: 30px;
    line-height: 40px;
    filter: drop-shadow(0px 0px 0px rgba(0, 0, 0, 0.2));
  }

  &:hover {
    box-shadow: 2px 2px 8px 2px rgba(0, 0, 0, 0.27);
    transform: scale(1.05);
    opacity: 1;

    .icon {
      font-size: 40px;
      filter: drop-shadow(3px 3px 1px rgba(0, 0, 0, 0.2));
    }
  }
`;

const BlockWidget = (props) => {
  const { name, icon, href, spinOnHover = false } = props;
  const [ref, isHovering] = useIsHovering();

  return (
    <Link ref={ref} to={href}>
      <WidgetStyle className='widget-block'>
        <h1>{name}</h1>
        <div className='icon'>
          {React.cloneElement(icon, { spin: spinOnHover && isHovering })}
        </div>
      </WidgetStyle>
    </Link>
  );
};

export default BlockWidget;
